import { faArchive, faArrowRotateLeft } from "@fortawesome/free-solid-svg-icons";
import type { FC } from "react";
import { useNavigate } from "react-router";
import { useApiCall } from "../api/api";
import type { ExamParticipant } from "../api/dto";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const ArchiveParticipantModal: FC<{ participant: ExamParticipant }> = (props) => {
  const { archiveParticipant, unarchiveParticipant } = useApiCall();
  const reload = useRefresh();
  const navigate = useNavigate();

  const archive = async () => {
    await archiveParticipant(props.participant.examId, props.participant.id);
    reload();
    navigate(`/exams/${props.participant.examId}`);
  };

  const unarchive = async () => {
    await unarchiveParticipant(props.participant.examId, props.participant.id);
    reload();
    navigate(`/exams/${props.participant.examId}`);
  };

  return (
    <>
      <div>
        Weet je zeker dat je de volgend participant{" "}
        <span>{props.participant.deletedAt ? "terug wilt zetten?" : "wilt archiveren?"}</span>
      </div>
      <div className={"font-bold"}>&middot; {props.participant.name}</div>
      <ModalFooter
        text={props.participant.deletedAt ? "Terugzetten" : "Archiveer"}
        icon={props.participant.deletedAt ? faArrowRotateLeft : faArchive}
        onSubmit={props.participant.deletedAt ? unarchive : archive}
      />
    </>
  );
};
